import _isNull from 'lodash/isNull';
import { format, startOfWeek, addDays, isPast, endOfDay } from 'date-fns';
import { getLocale, toDate } from '@/utils/date.utils';

export const formatDate = (date: Date | string | number, formatStr: string): string => {
  if (date === 'Invalid Date') {
    return;
  }
  const getDate = toDate(date);

  return format(getDate, formatStr, {
    locale: getLocale(),
  });
};

export function isNewDay(startDate: Date, endDate: Date) {
  return (
    (!_isNull(startDate) && isPast(endOfDay(startDate))) ||
    (!_isNull(endDate) && (isPast(endOfDay(startDate)) || isPast(endOfDay(endDate))))
  );
}

export function getWeekdays(weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6): Date[] {
  const start = startOfWeek(new Date(), { weekStartsOn });

  const days = [];
  for (let i = 0; i < 7; i++) {
    const day = addDays(start, i);
    days.push(day);
  }
  return days;
}

export function getCalendarStartEndDates() {
  const calendarStart = new Date(new Date().toDateString());
  return {
    calendarStart,
    calendarEnd: addDays(calendarStart, 365),
  };
}
